import { SET_TOPBAR_COURSE_NAVIGATION_SEARCH_STRING } from './actions';

export const TopbarCourseSearchString = (state = '', action) => {
  switch (action.type) {
    case SET_TOPBAR_COURSE_NAVIGATION_SEARCH_STRING: {
      return action.searchString;
    }
    default: {
      return state;
    }
  }
};
